export const styles = {
	mainWrapper: {
		flexGrow: 1,
		'& .MuiStepper-root': {
			padding: '24px'
		}
	},
	container: { marginTop: '16px' }
};
